import { apiClient } from "../../../lib/apiClient"
import type { ApiResponse } from "../../../types/apiResponse";

export const deleteChartAccount = async (id_chart_account: number) => {
  return apiClient<ApiResponse<null>>(`/v1/catalogs/chart_account/${id_chart_account}`, {
    method: "DELETE"
  });
}
